import React, { useState } from "react";
import { Row, Col, Container, Form, Button, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../services/api";
import { toast } from "react-toastify";

const NotificationCreate = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [url, setUrl] = useState("");
  const [scheduledAt, setScheduledAt] = useState("");
  const token = Cookies.get("token");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post(
        "/api/notifications",
        {
          title,
          body,
          image_url: imageUrl,
          url,
          scheduled_at: scheduledAt || null,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success(response.data.message);
      navigate("/notifications/index");
    } catch (error) {
      toast.error("Erro ao criar notificação.");
      console.error(error);
    }
  };

  return (
    <div id="content-page" className="content-inner">
      <Container>
        <Row>
          <Col sm="12">
            <Card className="position-relative inner-page-bg bg-primary p-5">
              <div
                className="inner-page-title"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "-webkit-fill-available",
                }}
              >
                <h3 className="text-white">Notificações Personalizadas</h3>
                <Link to="/notifications/index" className="text-white py-1 px-2">
                  <i className="icon material-symbols-outlined d-flex">
                    arrow_back
                  </i>
                </Link>
              </div>
            </Card>
          </Col>
          <Col sm="12">
            <Card className="p-4">
              <h4 className="mb-4">Criar Notificação Personalizada</h4>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Título</Form.Label>
                  <Form.Control
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Mensagem</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Imagem (URL)</Form.Label>
                  <Form.Control
                    type="url"
                    value={imageUrl}
                    onChange={(e) => setImageUrl(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Link de Redirecionamento</Form.Label>
                  <Form.Control
                    type="text"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Agendar para (opcional)</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={scheduledAt}
                    onChange={(e) => setScheduledAt(e.target.value)}
                  />
                </Form.Group>

                <Button type="submit" variant="primary">
                  ENVIAR
                </Button>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotificationCreate;
